/** @type {{ featured: string[], countries: string[], regions: Record<string, string[]> }} */
const SHAPE_HOMELAND_PLACES = {
  featured: [
    'Canada',
    'United States',
    'Pakistan',
    'India',
    'Italy',
    'France',
    'United Kingdom',
    'Mexico',
    'Philippines',
    'China',
    'Germany',
    'Australia',
  ],
  countries: [
    'Afghanistan', 'Albania', 'Algeria', 'Argentina', 'Australia', 'Austria', 'Bangladesh',
    'Belgium', 'Brazil', 'Bulgaria', 'Cambodia', 'Cameroon', 'Canada', 'Chile', 'China',
    'Colombia', 'Croatia', 'Czechia', 'Denmark', 'Egypt', 'Ethiopia', 'Finland', 'France',
    'Germany', 'Ghana', 'Greece', 'Hungary', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland',
    'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kenya', 'Korea, South', 'Lebanon',
    'Malaysia', 'Mexico', 'Morocco', 'Nepal', 'Netherlands', 'New Zealand', 'Nigeria', 'Norway',
    'Pakistan', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Romania', 'Russia', 'Saudi Arabia',
    'Serbia', 'Singapore', 'Slovakia', 'Somalia', 'South Africa', 'Spain', 'Sri Lanka', 'Sudan',
    'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tanzania', 'Thailand', 'Trinidad and Tobago',
    'Tunisia', 'Turkey', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States',
    'Venezuela', 'Vietnam', 'Zimbabwe',
  ],
  regions: {
    Canada: [
      'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador',
      'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island',
      'Quebec', 'Saskatchewan', 'Yukon',
    ],
    'United States': [
      'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
      'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois',
      'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts',
      'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
      'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
      'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
      'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
      'West Virginia', 'Wisconsin', 'Wyoming',
    ],
  },
};

class ShapeHomelandPlacePicker extends HTMLElement {
  #data = SHAPE_HOMELAND_PLACES;

  connectedCallback() {
    const countrySelect = this.querySelector('[data-country-select]');
    const regionWrap = this.querySelector('[data-region-wrap]');
    const regionSelect = this.querySelector('[data-region-select]');
    const regionLabel = this.querySelector('[data-region-label]');

    if (!countrySelect || !regionWrap || !regionSelect || !regionLabel) return;

    countrySelect.addEventListener('change', () => {
      this.#syncRegion(countrySelect, regionWrap, regionSelect, regionLabel);
    });

    this.#syncRegion(countrySelect, regionWrap, regionSelect, regionLabel);
  }

  #syncRegion(countrySelect, regionWrap, regionSelect, regionLabel) {
    const country = countrySelect.value;
    const regions = this.#data?.regions?.[country];

    regionSelect.innerHTML = '';

    if (!regions?.length) {
      regionWrap.hidden = true;
      regionSelect.disabled = true;
      regionSelect.required = false;
      regionSelect.removeAttribute('name');
      return;
    }

    regionWrap.hidden = false;
    regionSelect.disabled = false;
    regionSelect.required = false;
    regionSelect.setAttribute('name', regionSelect.dataset.propertyName);

    regionLabel.textContent =
      country === 'Canada' ? 'Province (optional)' : 'State (optional)';

    const entireCountry = document.createElement('option');
    entireCountry.value = '';
    entireCountry.textContent =
      country === 'Canada' ? 'All of Canada' : 'All of United States';
    entireCountry.selected = true;
    regionSelect.appendChild(entireCountry);

    for (const name of regions) {
      const option = document.createElement('option');
      option.value = name;
      option.textContent = name;
      regionSelect.appendChild(option);
    }
  }
}

if (!customElements.get('shape-homeland-place-picker')) {
  customElements.define('shape-homeland-place-picker', ShapeHomelandPlacePicker);
}
